import React, { useContext, useEffect, useMemo, useState } from "react";
import useMapCenter from "../../utils/useMapCenter";

type ContextValue = {
  ipLocationData: IpLocationResponse | undefined;
};

const GeolocationContext = React.createContext<ContextValue | undefined>(
  undefined
);

const GeolocationProvider: React.FC<{}> = (props) => {
  const [ipLocationData, setIpLocationData] = useState<
    IpLocationResponse | undefined
  >();
  const centerInH3HexRes4 = useMapCenter((state) => state.centerInH3HexRes4);
  const setCenter = useMapCenter((state) => state.setCenter);

  useEffect(() => {
    const fetchIpLocationData = async () => {
      try {
        const res = await fetch("https://freegeoip.app/json/", {
          headers: { "Content-Type": "text/plain" }
        });

        const response: IpLocationResponse = await res.json();

        setIpLocationData(response);
      } catch (e) {
        setIpLocationData(defaultIpLocationData);

        console.error(e);
      }
    };

    fetchIpLocationData();
  }, [setCenter, setIpLocationData]);

  useEffect(() => {
    if (ipLocationData && !centerInH3HexRes4) {
      const { latitude, longitude } = ipLocationData;
      setCenter([longitude, latitude]);
    }
  }, [centerInH3HexRes4, ipLocationData, setCenter]);

  const value = useMemo(() => ({ ipLocationData }), [ipLocationData]);

  return <GeolocationContext.Provider value={value} {...props} />;
};

const useGeolocation = (): ContextValue => {
  const context = useContext(GeolocationContext);
  if (context === undefined) {
    throw new Error(
      "useGeolocation must be used within an GeolocationProvider"
    );
  }
  return context;
};

export { useGeolocation, GeolocationProvider };

//
// Utils
//

interface IpLocationResponse {
  ip: string;
  country_code: string;
  country_name: string;
  region_code: string;
  region_name: string;
  city: string;
  zip_code: string;
  time_zone: string;
  latitude: number;
  longitude: number;
  metro_code: number;
}

const defaultIpLocationData: IpLocationResponse = {
  ip: "",
  country_code: "",
  country_name: "",
  region_code: "",
  region_name: "",
  city: "",
  zip_code: "",
  time_zone: "",
  latitude: 38.7558974,
  longitude: -9.199941,
  metro_code: 0
};
